export default "__VITE_ASSET__zzFqu15j__"